import React, { useState, useEffect } from "react";

import ReactStopwatch from "react-stopwatch";
import { API, graphqlOperation } from "aws-amplify";
import {
  updateOrder,
  updateAccount,
  updateUpdateDiscountArraybyShopId,
} from "../../graphql/myMutations";
import { getCurrentDiscountArraybyShopId } from "../../graphql/myQueries";
const initialHour = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};
const Stopwatch = ({ orderID, start, order }) => {
  //console.log("🚀 ~ file: newTimer.js ~ line 18 ~ Stopwatch ~ start", start)
  const [flag, setFlag] = useState(false);
  const [toTimer, setToTimer] = useState(null);

  useEffect(() => {
    if (start) setToTimer(calculateTimebyUpdatedDate("obj"));
    return () => {
      setToTimer(null);
    };
  }, [start]);

  async function cancelOrderbyTime(orderID) {
    //setVisible(false);
    //alert("Cancelar orden");
    let newDate = new Date();
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());

    var initialObj = {
      rol: "SYSTEM",
      subject: "THE SHOP EXCEEDED ANSWER TIME",
      details: "ANY",
      hour: newDate,
      protocol: 1,
    };
    //console.log("Cancelación: ", initialObj);
    try {
      var info = {
        id: orderID,
        status: "CANCELADA",
        canceled: JSON.stringify(initialObj),
        level: "FINALIZADO",
      };
      if (calculateTimebyUpdatedDate(start) === "00:00:00") {
        const result = await API.graphql(
          graphqlOperation(updateOrder, { input: info })
        );

        if (result) {
          updateCashBack(order);
          checkDiscount();
          setFlag(true);
          var tokens = JSON.parse(
            result.data.updateOrder.customer_id.notification_token
          );
          tokens.forEach((element) => {
            //console.log("Element: ", element);
            sendPushNotification(
              "¡Lo sentimos, tu orden a " +
                result.data.updateOrder.shop_id.shop_name +
                " ha sido cancelada!",
              element
            );
          });
          //window.location.reload();
        }
      }
      {
        console.log(
          "Intento cancelar pero no habia excedido el tiempo--------------->"
        );
      }

      /*Alert.alert(
        "¡Lo sentimos, tu orden ha sido cancelada!",
        "La tienda ha demorado mucho tiempo en atender tu orden"
      );*/
    } catch (error) {
      console.log(
        "Error al cancelar la orden por exceder el límite de tiempo de respuesta",
        error
      );
    }

    //Alert.alert("Por cancelar orden", "Cancelar la orden-------------->");
  }

  async function sendPushNotification(txt, expoPushToken) {
    //console.log(expoPushToken);
    const message = {
      to: expoPushToken,
      sound: "default",
      title: "Orden cancelada",
      body: txt,
      data: { someData: "goes here" },
    };

    try {
      await fetch("https://exp.host/--/api/v2/push/send", {
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        method: "POST",
        headers: {
          Accept: "application/json",
          "Accept-encoding": "gzip, deflate",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(message),
      });
    } catch (error) {
      console.log("Error al enviar la notifiacion, ", error);
    }
  }

  async function updateCashBack(order) {
    // console.log("Por cancelar la orden------> y acutalizar NC ");
    var total = order.total;
    var cashBack = (total * (order.shop_id.percentage_traded.value / 100)) / 4;
    /*console.log("NC: ", order.customer_id.nikucoins);
    console.log("Quitar: ", cashBack);
    console.log("Porcentaje cedido: ", order.shop_id.percentage_traded.value);
    console.log("Total de la compra: ", total);*/
    var newNC =
      order.customer_id.nikucoins - cashBack < 0
        ? 0
        : order.customer_id.nikucoins - cashBack;
    //console.log("🚀 NC con el descuento de la orden", newNC);
    try {
      var updateNC = {
        id: order.customer_id.id,
        nikucoins: newNC,
      };
      const result = await API.graphql(
        graphqlOperation(updateAccount, { input: updateNC })
      );
    } catch (error) {
      console.log("Error al actualizar las NC del cliente", error);
    }
  }

  async function checkDiscount() {
    //console.log("Por validar los cambios del descuento");
    try {
      const result = await API.graphql(
        graphqlOperation(getCurrentDiscountArraybyShopId, {
          id: order.shop_id.id,
        })
      );
      var currentArrayBD = JSON.parse(result.data.getShop.discountsArray);
      //console.log("El arreglo ANTES---->", JSON.stringify(currentArrayBD));
      var found = false; //si encontré el valor en el arreglo
      var added = false; //para saber si ya lo agregué
      for (let x = 0; x < currentArrayBD.length; x++) {
        if (!added) {
          var elementArray = currentArrayBD[x];
          //console.log("Arreglo que se recorre: ", elementArray);
          found = elementArray.find((element) => element === order.percentage);

          if (found) {
            //console.log("Lo encontré en el arreglo: " + x);
            /////
            var quantity = 0;
            var currentB = JSON.parse(
              order.shop_id.percentage_traded.array_ofDiscount
            );
            var quantityA = 0; //cantidad de elementos iguales al porcentage otorgado y que se encuentran en el arreglo actual de la tienda
            //Buscamos en el arreglo inicial (reset) cuantos elementos del arreglo deben de estar
            //de tal forma que si deben existir 2 veces un 85, nos permita saber si debemos o no agregar un valor
            currentB.forEach((element) => {
              // console.log(":--->" + element + " vs " + percentageO);
              if (element === order.percentage) {
                /*console.log(
                  "Encontrado------------->" +
                    element +
                    "-----" +
                    order.percentage
                );*/
                quantity++;
              }
            });

            if (quantity == 1) {
              //console.log("Cierto, no debe de agregarse", quantity);
            } else {
              for (let z = 0; z < currentArrayBD.length; z++) {
                var currentA = currentArrayBD[z];
                quantityA = 0;
                currentA.forEach((element) => {
                  if (element === order.percentage) {
                    //console.log("Encontrado", element);
                    quantityA++;
                  }
                });
                if (quantityA < quantity) {
                  //Si la cantidad de elementos que hay en el arreglo actual de la tienda
                  //es menor a la que debe de existir por definición (reset) entonces agregaremos el valor
                  //sin afectar la cantidad de elementos del arreglo inicial
                  /*console.log(
                    "Se agregará el elemento " +
                      order.percentage +
                      " al arreglo: " +
                      currentA
                  );*/
                  currentA.push(order.percentage);
                  added = true;
                } /* else {
                  console.log(
                    z +
                      "---No debe agregarse nada---->En el arreglo inicial debe existir: " +
                      quantity +
                      " En el arreglo actual hay: " +
                      quantityA +
                      " valores de: " +
                      order.percentage +
                      "\n------>" +
                      currentA
                  );
                } */
              }
            }
          } else {
            //console.log("No lo encontré en el arreglo: " + x);
            elementArray.push(order.percentage);

            added = true;
          }
        } /* else {
          console.log("El elemento ya ha sido agregado a algun arreglo");
        } */
      }
      if (added) {
        updateArrayDiscountDB(currentArrayBD);
      }/*  else {
        console.log("No hay modificaciones");
      } */
    } catch (error) {
      console.log("Error al obtener los descuentos de la tienda", error);
      //Alert.alert("¡Oops!", "Algo salió mal con el descuento");
    }
  }

  async function updateArrayDiscountDB(array) {
    //console.log("El arreglo normal----------------------->", array);
    try {
      //console.log("Item nuevo", item);
      var jsonArray = JSON.stringify(array);
      //console.log("El arreglo en JSON", jsonArray);
      const result = await API.graphql(
        graphqlOperation(updateUpdateDiscountArraybyShopId, {
          input: {
            id: order.shop_id.id,
            discountsArray: jsonArray,
          },
        })
      );
      ///
    } catch (error) {
      console.log(
        "Error al actualizar el arreglo de descuentos en la base de datos",
        error
      );
    }
  }

  /*Función que para la hora actual (UTC) del sistema a la hora local
    Retorna un objeto que contiene la hora y minutos(int) para posteriormente 
    validar los rangos de horarios*/
  function convertUTCDateToLocalDate(type) {
    var newDate = new Date();
    //console.log("Fecha actual: ", newDate);
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    var currentDateToString = newDate.toISOString();

    var myHour = {
      hour: parseInt(currentDateToString.substring(11, 13)),
      minutes: parseInt(currentDateToString.substring(14, 16)),
      type: parseInt(currentDateToString.substring(11, 13)) < 12 ? "am" : "pm",
    };
    //return myHour;
    if (type === "date") return currentDateToString;
    else return myHour;
  }

  function calculateTimebyUpdatedDate(type) {
    let today = new Date(convertUTCDateToLocalDate("date"));
    let orderDate = new Date(start);

    let diffMs = today - orderDate; // milliseconds between now & Christmas
    let days = Math.floor(diffMs / 86400000); // days
    let hours = Math.floor((diffMs % 86400000) / 3600000); // hours
    let minutes = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    var seconds = Math.round((((diffMs % 86400000) % 3600000) % 60000) / 1000); // seconds
    /*  console.log(
      " tiempo transcurrido:---->" +
        days +
        " día, " +
        hours +
        " horas, " +
        minutes
    ); */
    var toReturn =
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);
    if (type === "obj") {
      return { hours, minutes, seconds, days };
    } else {
      return toReturn;
    }
  }

  return (
    <>
      {toTimer && (
        <ReactStopwatch
          seconds={toTimer.seconds}
          minutes={toTimer.minutes}
          hours={toTimer.hours}
          //limit={"10:59:00"}
          onChange={({ hours, minutes, seconds }) => {
            //console.log("Cambios " + hours + ":" + minutes + ":" + seconds);
          }}
          onCallback={() => {
            if (!flag) {
              console.log(
                "Cancelar item: " +
                  orderID +
                  " limite: " +
                  calculateTimebyUpdatedDate()
              );
              //cancelOrderbyTime(orderID);
            }
          }}
          render={({ formatted, hours, minutes, seconds }) => {
            return (
              <div>
                <p>
                  {toTimer.days < 10
                    ? "0" + toTimer.days + ":"
                    : toTimer.days + ":"}
                  {formatted}
                </p>
              </div>
            );
          }}
        />
      )}
    </>
  );
};

export default Stopwatch;
